export const ASSIGNED_TO_TYPES = [
  { value: "TEACHER", label: "Teacher" },
  { value: "CLASSROOM", label: "Classroom" },
  { value: "STAFF", label: "Staff member" },
  { value: "DEPARTMENT", label: "Department" },
];

export function totalIssued(item) {
  return (item?.issuances || []).reduce((sum, row) => sum + (Number(row.quantity) || 0), 0);
}

export function availableQuantity(item) {
  const total = Number(item?.quantity) || 0;
  return Math.max(0, total - totalIssued(item));
}

export function assigneeTypeLabel(type) {
  if (!type) return "—";
  return ASSIGNED_TO_TYPES.find((t) => t.value === type)?.label || type;
}

export function issuanceAssigneeLabel(row) {
  if (!row) return "—";
  if (row.assignedToName) return row.assignedToName;
  return assigneeTypeLabel(row.assignedToType);
}

export function issuanceSummary(item) {
  const issuances = item?.issuances || [];
  if (!issuances.length) return "In storage";
  if (issuances.length === 1) {
    return `${issuanceAssigneeLabel(issuances[0])} (${issuances[0].quantity})`;
  }
  return `${issuances.length} assignments`;
}
